// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddMarksToRoutePage.module.css */

.AddMarksToRoutePage_container__I7bKN {
  flex: 1 1;
  font-family: Arial, sans-serif;
  padding: 10px;
  height: 100%;
  overflow-y: auto;
}

.AddMarksToRoutePage_dashboardHeader__kFmCu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-bottom: 16px;
}

.AddMarksToRoutePage_dateFilter__BNGGG {
  display: flex;
  gap: 8px;
}

.AddMarksToRoutePage_input__YKz-n {
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex: 1 1;
  min-width: 0;
  box-sizing: border-box;
}

/* Ensure date input fits */
.AddMarksToRoutePage_rangeRow__get5U input[type="date"] {
  flex: 0 0 120px;
  max-width: 120px;
}

.AddMarksToRoutePage_routeCardContainer__owHWX {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 16px;
}

@media (max-width: 768px) {
  .AddMarksToRoutePage_routeCardContainer__owHWX {
    grid-template-columns: 1fr;
  }
}

.AddMarksToRoutePage_routeCard__vIZKa {
  background: #fafafa;
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.AddMarksToRoutePage_duplicateOriginal__VgoGy {
  background-color: #fff9c4;
  border-color: #ffe082;
}

.AddMarksToRoutePage_duplicate__-xyWR {
  background-color: #ffebee;
  border-color: #ef9a9a;
}

.AddMarksToRoutePage_routeHeader__6t9Dh h3 {
  margin: 0;
  font-size: 16px;
}

.AddMarksToRoutePage_routeMetaGrid__Gf1yO {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 6px;
  align-items: start;
}

.AddMarksToRoutePage_routeMetaGrid__Gf1yO p {
  margin: 0;
  font-size: 13px;
  overflow-wrap: break-word;
}

/* Container for each range with stronger background */
.AddMarksToRoutePage_rangeContainer__JZhtr {
  position: relative;
  background: #eef1f5;
  border: 1px solid #d1d5da;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

/* Delete button */
.AddMarksToRoutePage_removeBtn__McVtG {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #e57373;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.AddMarksToRoutePage_removeBtn__McVtG:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.AddMarksToRoutePage_rangeRow__get5U {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
  align-items: center;
}

/* Align select to left, remove default padding-left */
.AddMarksToRoutePage_rangeRow__get5U select {
  padding-left: 6px;
  flex: 1 1;
  min-width: 0;
}

.AddMarksToRoutePage_addBtn__ivoxU {
  background-color: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  align-self: flex-start;
  transition: background-color 0.3s;
}

.AddMarksToRoutePage_addBtn__ivoxU:hover {
  background-color: #218838;
}


.AddMarksToRoutePage_routeCardFooter__t853e {
  display: flex;
  flex-direction: column;    /* ставим колоночный режим */
  align-items: flex-start;   /* или flex-end, если нужно выравнять по правому краю */
  gap: 8px;                  /* отступ между кнопкой и сообщением */
  margin-top: auto;
}

.AddMarksToRoutePage_submitBtn__oNEuV {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.AddMarksToRoutePage_submitBtn__oNEuV:hover {
  background-color: #0056b3;
}

.AddMarksToRoutePage_viewBtn__I-aje {
  background: #17a2b8;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 8px;
}
.AddMarksToRoutePage_viewBtn__I-aje:hover {
  background: #138496;
}
.AddMarksToRoutePage_marksList__rG1fJ {
  font-size: 13px;
  color: #333;
  margin-bottom: 12px;
  padding: 6px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.AddMarksToRoutePage_serverMessage__qNGji {
  margin-top: 8px;
  padding: 8px;
  background: #e9f7ef;
  border: 1px solid #bdecb6;
  border-radius: 4px;
  font-size: 13px;
  color: #155724;
}

.AddMarksToRoutePage_clearAllBtn__4ydwm {
  margin-left: 0.5rem;
  padding: 0.4rem 0.8rem;
  background-color: #dc3545;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.AddMarksToRoutePage_clearAllBtn__4ydwm:hover {
  background-color: #c82333;
}`, "",{"version":3,"sources":["webpack://./src/modules/Developer/TestPages/AddMarksToRoute/AddMarksToRoutePage.module.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,SAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;EACjB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,sBAAsB,KAAK,4BAA4B;EACvD,uBAAuB,IAAI,uDAAuD;EAClF,QAAQ,mBAAmB,sCAAsC;EACjE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["/* AddMarksToRoutePage.module.css */\r\n\r\n.container {\r\n  flex: 1;\r\n  font-family: Arial, sans-serif;\r\n  padding: 10px;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.dashboardHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.dateFilter {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.input {\r\n  padding: 6px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  flex: 1;\r\n  min-width: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Ensure date input fits */\r\n.rangeRow input[type=\"date\"] {\r\n  flex: 0 0 120px;\r\n  max-width: 120px;\r\n}\r\n\r\n.routeCardContainer {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .routeCardContainer {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.routeCard {\r\n  background: #fafafa;\r\n  border: 1px solid #ccc;\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n.duplicateOriginal {\r\n  background-color: #fff9c4;\r\n  border-color: #ffe082;\r\n}\r\n\r\n.duplicate {\r\n  background-color: #ffebee;\r\n  border-color: #ef9a9a;\r\n}\r\n\r\n.routeHeader h3 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n}\r\n\r\n.routeMetaGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\r\n  gap: 6px;\r\n  align-items: start;\r\n}\r\n\r\n.routeMetaGrid p {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n/* Container for each range with stronger background */\r\n.rangeContainer {\r\n  position: relative;\r\n  background: #eef1f5;\r\n  border: 1px solid #d1d5da;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n/* Delete button */\r\n.removeBtn {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  background: #e57373;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 24px;\r\n  height: 24px;\r\n  font-size: 16px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.removeBtn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rangeRow {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 8px;\r\n  align-items: center;\r\n}\r\n\r\n/* Align select to left, remove default padding-left */\r\n.rangeRow select {\r\n  padding-left: 6px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.addBtn {\r\n  background-color: #28a745;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 6px 12px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  align-self: flex-start;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.addBtn:hover {\r\n  background-color: #218838;\r\n}\r\n\r\n\r\n.routeCardFooter {\r\n  display: flex;\r\n  flex-direction: column;    /* ставим колоночный режим */\r\n  align-items: flex-start;   /* или flex-end, если нужно выравнять по правому краю */\r\n  gap: 8px;                  /* отступ между кнопкой и сообщением */\r\n  margin-top: auto;\r\n}\r\n\r\n.submitBtn {\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 8px 16px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.submitBtn:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.viewBtn {\r\n  background: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 6px 12px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  margin-bottom: 8px;\r\n}\r\n.viewBtn:hover {\r\n  background: #138496;\r\n}\r\n.marksList {\r\n  font-size: 13px;\r\n  color: #333;\r\n  margin-bottom: 12px;\r\n  padding: 6px;\r\n  background: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n.serverMessage {\r\n  margin-top: 8px;\r\n  padding: 8px;\r\n  background: #e9f7ef;\r\n  border: 1px solid #bdecb6;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  color: #155724;\r\n}\r\n\r\n.clearAllBtn {\r\n  margin-left: 0.5rem;\r\n  padding: 0.4rem 0.8rem;\r\n  background-color: #dc3545;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.clearAllBtn:hover {\r\n  background-color: #c82333;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddMarksToRoutePage_container__I7bKN`,
	"dashboardHeader": `AddMarksToRoutePage_dashboardHeader__kFmCu`,
	"dateFilter": `AddMarksToRoutePage_dateFilter__BNGGG`,
	"input": `AddMarksToRoutePage_input__YKz-n`,
	"rangeRow": `AddMarksToRoutePage_rangeRow__get5U`,
	"routeCardContainer": `AddMarksToRoutePage_routeCardContainer__owHWX`,
	"routeCard": `AddMarksToRoutePage_routeCard__vIZKa`,
	"duplicateOriginal": `AddMarksToRoutePage_duplicateOriginal__VgoGy`,
	"duplicate": `AddMarksToRoutePage_duplicate__-xyWR`,
	"routeHeader": `AddMarksToRoutePage_routeHeader__6t9Dh`,
	"routeMetaGrid": `AddMarksToRoutePage_routeMetaGrid__Gf1yO`,
	"rangeContainer": `AddMarksToRoutePage_rangeContainer__JZhtr`,
	"removeBtn": `AddMarksToRoutePage_removeBtn__McVtG`,
	"addBtn": `AddMarksToRoutePage_addBtn__ivoxU`,
	"routeCardFooter": `AddMarksToRoutePage_routeCardFooter__t853e`,
	"submitBtn": `AddMarksToRoutePage_submitBtn__oNEuV`,
	"viewBtn": `AddMarksToRoutePage_viewBtn__I-aje`,
	"marksList": `AddMarksToRoutePage_marksList__rG1fJ`,
	"serverMessage": `AddMarksToRoutePage_serverMessage__qNGji`,
	"clearAllBtn": `AddMarksToRoutePage_clearAllBtn__4ydwm`
};
export default ___CSS_LOADER_EXPORT___;
